var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoLocker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 65,
    r: 62.25,
    stroke: "#26DDE6",
    strokeWidth: 4.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 94H39C37.8954 94 37 93.1046 37 92V37C37 35.8954 37.8954 35 39 35H63C64.1046 35 65 35.8954 65 37V92C65 93.1046 64.1046 94 63 94Z",
    stroke: "#26DDE6",
    strokeWidth: 4.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91 94H67C65.8954 94 65 93.1046 65 92V37C65 35.8954 65.8954 35 67 35H91C92.1046 35 93 35.8954 93 37V92C93 93.1046 92.1046 94 91 94Z",
    stroke: "#26DDE6",
    strokeWidth: 4.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5023 47.5H59.0023M43.5023 54H59.0023M43.5 60.5H59M71.5023 47.5H87.0023M71.5023 54H87.0023M71.5 60.5H87M87 72.5V82M59 72.5V82",
    stroke: "#26DDE6",
    strokeWidth: 4.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 24L113.5 104",
    stroke: "#26DDE6",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLocker);
export default __webpack_public_path__ + "static/media/no_locker.8bc6ac39a59b1006b25c2e950a3dffcf.svg";
export { ForwardRef as ReactComponent };